import Vue from 'vue'
import App from './App'
import router from './router'
import stores from './stores'
import VueClipboard from 'vue-clipboard2'
import component from './components'
import './filters'
import outMsg from '@/mixins/message-mixins'
import 'windi.css'
import VueCompositionAPI from '@vue/composition-api'
import JElementBiz from '@jdcloud/jelement-biz'
import '@jdcloud/jelement-biz/dist/theme-default/index.css'
Vue.config.productionTip = process.env.NODE_ENV === 'development'
Vue.use(VueCompositionAPI)
Vue.use(JElementBiz, {
  env: derivativeConfig.bizServerUrl,
})
Vue.use(VueClipboard)
Vue.use(component)
Vue.mixin(outMsg)
window.toRoutePath = function (url) {
  if (!url || url.length <= 0) {
    return
  }
  if (url.charAt(0) !== '/') {
    url = '/' + url
  }
  router.push(url)
}

new Vue({
  el: '#app',
  store: stores,
  router,
  components: { App },
  template: '<App/>',
})
